import { createFileRoute } from "@tanstack/react-router";
import ElectricHub from "@/pages/hub/ElectricHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/hub/electric/")({
  head: () => routeHead("/hub/electric/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ElectricHub />
  );
}
